import React, { useState } from "react";
import { TextArea } from "semantic-ui-react";
import { toast } from "react-toastify";
import {resolveDisputeApi} from "../../../api/jobApi";
import Button from "../../input/Button";

const JobDisputeResolution = ({ jobId, onSuccess }) => {
    const [remark, setRemark] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleResolve = async () => {
        if (!remark.trim()) {
            toast.error("Please enter resolve remark", {
                autoClose: 5000,
                containerId: "Modal"
            });
            return;
        }

        setIsLoading(true);
        try {
            const payload = {
                jobId: jobId,
                disputeResolve: 1,
                disputeResolveRemark: remark
            };

            await resolveDisputeApi(payload);

            toast.success("Dispute Resolved Successfully", {
                autoClose: 5000,
                containerId: "Main"
            });

            onSuccess(jobId);

        } catch (error) {
            console.error(error);
            toast.error("Failed to resolve dispute", {
                autoClose: 5000,
                containerId: "Modal"
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="ui segment">
            <h3 className="ui header">Resolve Job Dispute</h3>
            <div className="ui form">
                <div className="field">
                    <label>Resolve Remark </label>
                    <TextArea
                        placeholder="resolve remark"
                        value={remark}
                        onChange={(e, { value }) => setRemark(value)}
                        rows={5}
                    />
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
                    <Button
                        className="ui yellow button"
                        label="Mark as Resolved"
                        onClick={handleResolve}
                        disabled={isLoading}
                        loading={isLoading}
                    />
                </div>
            </div>
        </div>
    );
};

export default JobDisputeResolution;